import { render, staticRenderFns } from "./SolidButton.vue?vue&type=template&id=08bbca66&"
import script from "./SolidButton.vue?vue&type=script&lang=js&"
export * from "./SolidButton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports